import Chat from './components/chat/Chat';

export default Chat;
